<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(save)">
                      <div class="form-row">
                        <div class="form-group col-md-6">
                          <ValidationProvider name="Name" rules="required" v-slot="{ errors }">
                            <label for="Name">
                              {{ $t('Name') }}:
                            </label>
                            <input
                                type="text"
                                id="Name"
                                class="form-control"
                                v-model="vehicle_brand.name"
                                :class="{ 'is-invalid': errors.length }"
                                autocomplete="new-password"
                                placeholder=""
                            />
                            <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                          </ValidationProvider>
                        </div>
                        <div class="form-group col-md-6">
                          <ValidationProvider name="Status" rules="required" v-slot="{ errors }">
                            <label for="Status">
                              {{ $t('Status') }}:
                            </label>
                            <select
                                class="form-control"
                                v-model="vehicle_brand.status"
                                :class="{ 'is-invalid': errors.length }"
                            >
                              <option value="1"> {{ $t('Active') }}</option>
                              <option value="0"> {{ $t('Inactive') }}</option>
                            </select>
                            <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                      <span class="required_fields">
                        <span class="required">*</span>
                        <strong> {{ $t('Required Fields') }}</strong>
                      </span>
                      <div class="block text-right">
                        <b-button variant="outline-secondary" class="btn btn-back" @click="$router.go(-1)">
                          <i class="fa fa-arrow-left"></i> {{ $t('To Go Back') }}
                        </b-button>

                        <b-button type="submit" variant="primary" class="ml-1">
                          {{ $t('Save') }}
                          <i class="fa fa-save"></i>
                        </b-button>
                      </div>
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ValidationObserver, ValidationProvider, extend} from "vee-validate";
import {required} from "vee-validate/dist/rules";
import axios from "axios";
import BaseCrud from "../../layouts/Base/BaseCrud";
import {BButton} from "bootstrap-vue";

extend("required", required);

export default {
  data() {
    return {
      vehicle_brand: {
        name: '',
        status: "1"
      },
      errors: undefined,
    };
  },
  methods: {
    save() {
      const self = this;
      let api = self.$store.state.api + "vehicle_brands";

      if (self.vehicle_brand.id) {
        self.vehicle_brand._method = "PUT";
        api += "/" + self.vehicle_brand.id;
      }

      axios
          .post(api, self.vehicle_brand)
          .then(() => {
            self.$message(
                this.$t('Success'),
                this.$t('Information saved successfully'),
                "success"
            );
            this.$router.push("/vehicle_brands");
          })
          .catch(error => {
            this.$error(error);
          });
    },
    getVehicleBrand(id) {
      const self = this;
      const api = self.$store.state.api + "vehicle_brands/" + id;

      axios
          .get(api)
          .then(response => {
            self.vehicle_brand = response.data.data[0];
          })
          .catch(error => {
            this.$error(error);
          });
    },
  },
  mounted() {
    const self = this;
    let id = self.$route.params.id;

    if (id) {
      self.getVehicleBrand(id);
    }
  },
  components: {
    BButton,
    BaseCrud,
    ValidationObserver,
    ValidationProvider,
  },
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
